import type { DateFilterValue, DateRangeValue, RelativeDateRange } from '../types/filter-types.ts';

/**
 * Type guard to check if a value is a DateRangeValue
 */
export function isDateRangeValue(range: unknown): range is DateRangeValue {
    return (
        range !== null &&
        typeof range === 'object' &&
        ('from' in range || 'to' in range) &&
        !('unit' in range) &&
        !('count' in range)
    );
}

/**
 * Type guard to check if a value is a RelativeDateRange
 */
export function isRelativeDateRange(range: unknown): range is RelativeDateRange {
    return (
        range !== null &&
        typeof range === 'object' &&
        'unit' in range &&
        'count' in range &&
        typeof (range as Record<string, unknown>).unit === 'string' &&
        typeof (range as Record<string, unknown>).count === 'number' &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- legacy code
        ['days', 'weeks', 'months'].includes((range as Record<string, unknown>).unit as string)
    );
}

/**
 * Validates a DateFilterValue
 */
export function isValidDateFilterValue(value: unknown): value is DateFilterValue {
    return value === null || isDateRangeValue(value) || isRelativeDateRange(value);
}
